export enum StreamingStatusEnum {
  Idle = 'idle',
  Connecting = 'connecting',
  Streaming = 'streaming',
  Error = 'error',
}
